<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Edit Automation</h3>
    </template>

    <template #default="modalProps">
      <AutomationForm
        :automation="automation"
        :submit-action="submitAction"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import AutomationForm from './AutomationForm.vue';

export default {
  components: {
    AutomationForm,
  },

  props: {
    automation: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions('ui/automations', {
      updateAutomation: 'update',
    }),
    submitAction(formData) {
      const { uuid: automationUuid } = this.automation;
      return this.updateAutomation({ automationUuid, formData })
        .then((response) => {
          this.$refs.modal.doClose();
          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
